import { FC, useState } from "react"
import { Box, Button, Collapse, Container, Typography } from "@mui/material"
import { Balances, TopUpTable } from "../components"
import { useTitle } from "@/core/hooks"
import { CreateTopUpForm } from "../components/forms/createTopUpForm"

interface IProps {}

export const TopUpPage: FC<IProps> = (props) => {
  const [expanded, setExpanded] = useState(false)
  useTitle(`PR ADV - Пополнения`)

  return (
    <Container maxWidth={false}>
      <Box mb={3}>
        <Box mb={1} sx={{ display: "flex", flexDirection: "row-reverse" }}>
          <Button onClick={() => setExpanded(!expanded)}>
            {expanded ? "Отмена" : "Пополнить баланс"}
          </Button>
        </Box>
        <Collapse in={expanded}>
          <Typography variant="h5">Пополнение баланса</Typography>
          <CreateTopUpForm />
        </Collapse>
      </Box>
      <Box mt={5}>
        <Typography variant="h5">Балансы</Typography>
        <Box>
          <Balances />
        </Box>
      </Box>
      <Box mt={5}>
        <Typography variant="h5">Пополнения</Typography>
        <Box height="85vh">
          <TopUpTable />
        </Box>
      </Box>
    </Container>
  )
}
